import {get} from 'lodash';

export default (state = {}, {clientId, stateName, stateValue}: any) => {
  return {
    ...state,
    allOrdersState: {
      ...get(state, 'allOrdersState', {}),
      [clientId]: {
        ...get(state, `allOrdersState.${clientId}`, {}),
        [stateName]: stateValue,
      },
    },
  };
};
